module.exports = {
    "oh_url": "https://ophub.litedev.com",
    "chs_url": "https://chs.litedev.com",
    "ph_url": "https://phub.litedev.com",
    "com_url": "https://chub.litedev.com",
    "invoiceDate": "2021-09-06",
    "VAT": 0.15,
    "website_url":"https://sanarweb.litedev.com/",
    jwtSecret: "fgxzbmvhgkiteqw135rodjdxff+=sdhbkvnxzm+=",
    encryptedKey: "fsfhjkgweer+12fbmvngdvdfr+=="
}



//////////////////
// WEBPACK FOOTER
// ./config/endpoints.js
// module id = VPkb
// module chunks = 12